;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="75f649f7-a0c5-4ae7-a6ba-e62fb2aaf17c",e._sentryDebugIdIdentifier="sentry-dbid-75f649f7-a0c5-4ae7-a6ba-e62fb2aaf17c")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8933],{

/***/ 60988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgRating(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 110 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.45 20a.98.98 0 01-.6-.2c-.34-.25-.5-.7-.4-1.21l.87-5.37a.95.95 0 00-.2-.63L.4 8.8C.05 8.43-.08 8 .05 7.57c.12-.41.48-.7.97-.77L6.17 6c.21-.05.4-.18.51-.37L9 .73C9.2.26 9.57 0 10 0c.42 0 .78.26 1 .73l2.3 4.88c.08.16.35.38.5.39l5.17.79c.5.07.85.35.98.77.12.42 0 .87-.35 1.22l-3.74 3.8c-.11.13-.21.46-.19.63l.88 5.37c.08.5-.07.95-.4 1.21-.34.25-.8.26-1.23.03l-4.61-2.54a.84.84 0 00-.63 0l-4.62 2.54c-.19.1-.4.17-.61.17zm22.5 0a.98.98 0 01-.6-.2c-.34-.25-.5-.7-.4-1.21l.87-5.37a.95.95 0 00-.2-.63L22.9 8.8c-.35-.36-.48-.8-.35-1.22.12-.41.48-.7.97-.77l5.15-.8c.21-.05.4-.18.51-.37L31.5.73c.22-.47.58-.73 1-.73.43 0 .8.26 1 .72l2.32 4.89c.07.16.34.37.5.39l5.16.78c.5.08.85.35.98.78.12.42 0 .87-.35 1.22l-3.74 3.8c-.11.12-.21.46-.19.62l.88 5.38c.08.5-.07.95-.4 1.2-.34.26-.79.27-1.23.03l-4.61-2.53a.84.84 0 00-.62 0l-4.63 2.53c-.19.11-.4.18-.61.18l-.01.01zm22.5 0a.98.98 0 01-.6-.2c-.34-.25-.5-.7-.4-1.21l.87-5.37a.95.95 0 00-.2-.63l-3.73-3.8c-.35-.36-.47-.8-.35-1.22.13-.41.5-.7.98-.77l5.15-.8c.21-.05.4-.18.51-.37L54 .73c.23-.47.6-.73 1.02-.73.42 0 .78.26 1 .72l2.3 4.89c.08.16.35.37.5.39l5.17.78c.5.08.85.35.98.78.12.42 0 .87-.35 1.22l-3.74 3.8c-.11.12-.21.46-.19.62l.88 5.38c.08.5-.07.95-.4 1.2-.34.26-.8.27-1.23.03l-4.61-2.53a.84.84 0 00-.63 0l-4.62 2.53c-.19.11-.4.18-.61.18l-.02.01zm22.5 0a.98.98 0 01-.6-.2c-.34-.25-.5-.7-.4-1.21l.87-5.37a.95.95 0 00-.2-.63l-3.73-3.8c-.35-.36-.47-.8-.35-1.22.13-.41.49-.7.98-.77l5.15-.8c.2-.05.4-.18.51-.37l2.31-4.9c.23-.47.59-.73 1.01-.73.43 0 .8.26 1 .72l2.32 4.89c.07.16.33.37.5.39l5.16.78c.5.08.85.35.97.78.13.42 0 .87-.35 1.22l-3.73 3.8c-.12.12-.22.46-.2.62l.88 5.38c.1.5-.06.95-.4 1.2-.33.26-.78.27-1.22.03l-4.61-2.53a.84.84 0 00-.63 0l-4.62 2.53c-.19.11-.4.18-.61.18l-.02.01zm22.5 0a.98.98 0 01-.6-.2c-.35-.25-.5-.7-.4-1.21l.87-5.37a.95.95 0 00-.2-.63l-3.73-3.8c-.35-.36-.47-.8-.35-1.22.13-.41.49-.7.98-.77l5.15-.8c.2-.05.39-.18.5-.37L99 .73c.22-.48.58-.73 1-.73.43 0 .8.26 1 .72l2.32 4.89c.07.16.33.37.5.39l5.16.78c.5.08.85.35.97.78.13.42 0 .87-.35 1.22l-3.73 3.8c-.12.12-.22.46-.2.62l.88 5.38c.09.5-.06.95-.4 1.2-.33.26-.78.27-1.22.03l-4.61-2.53a.84.84 0 00-.63 0l-4.62 2.53c-.2.11-.4.18-.62.18V20z",
    fill: "currentColor"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgRating);

/***/ }),

/***/ 10429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);





var renderTitle = function(param) {
    var title = param.title, attributes = param.attributes, shouldBeH1 = param.shouldBeH1;
    return shouldBeH1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, attributes), {
        children: title
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, attributes), {
        children: title
    }));
};
var Headline = function(param) {
    var classNames = param.classNames, extraElement = param.extraElement, _shouldBeH1 = param.shouldBeH1, shouldBeH1 = _shouldBeH1 === void 0 ? true : _shouldBeH1, _smallerFont = param.smallerFont, smallerFont = _smallerFont === void 0 ? false : _smallerFont, subTitle = param.subTitle, title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-sm leading-[17.50px]",
                children: typeof subTitle === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    id: subTitle
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: subTitle
                })
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("items-baseline gap-2 lg:flex lg:gap-3", classNames),
                children: [
                    renderTitle({
                        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            id: title
                        }),
                        attributes: {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(smallerFont ? "tracking-wide text-2xl leading-[30px] font-mindset" : "tracking-wider lg:leading-[51px] font-normal text-2xl lg:text-[40px] leading-[30px] font-mindset")
                        },
                        shouldBeH1: shouldBeH1
                    }),
                    extraElement
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Headline);


/***/ }),

/***/ 19287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_nav_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71707);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);






/**
 * Button for the hero filter component.
 * With memo, only the affected filter button will be re-rendered, if a button is updated,
 * reducing the overall rendering time.
 */ var HeroFilterButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(function(param) {
    var filterName = param.filterName, handleToggleFilter = param.handleToggleFilter, isSelected = param.isSelected, size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_nav_item__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onClick: function() {
            return handleToggleFilter(filterName);
        },
        selected: isSelected,
        className: "col-span-3 px-2! py-1! lg:justify-start lg:py-1.5!",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex flex-col items-center justify-center gap-1 lg:flex-row", size === "sm" && "flex-row!"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("h-[48px] w-[48px] lg:h-[30px] lg:w-[30px]", size === "sm" && "h-[30px]! w-[30px]!"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: "/images/collection/hero-filter/hero_filter_".concat(filterName, ".png"),
                        alt: filterName,
                        width: 96,
                        height: 96
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-xs lg:text-sm",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        id: "common:hero-filter:".concat(filterName)
                    })
                })
            ]
        })
    });
});
HeroFilterButton.displayName = "HeroFilterButton";
/* harmony default export */ __webpack_exports__["Z"] = (HeroFilterButton);


/***/ }),

/***/ 71707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);





/**
 * NavItem is a functional component that renders a button with various styles based on the props.
 */ var NavItem = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, disabled = _param.disabled, disabledStyle = _param.disabledStyle, selected = _param.selected, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled",
        "disabledStyle",
        "selected",
        "onClick"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex items-center justify-center gap-2 rounded-md px-3 py-2.5 text-sm leading-5 ring-1 ring-inset	ring-grey-300 lg:hover:ring-grey-800", selected && disabledStyle ? "font-medium text-text-primary line-through shadow-xs ring-2 ring-grey-800" : selected ? "font-medium text-text-primary shadow-xs ring-2 ring-grey-800" : disabledStyle ? "text-text-light-bg-secondary line-through ring-grey-100 lg:hover:ring-grey-100" : "font-normal text-text-secondary", className),
        disabled: disabled,
        onClick: function(event) {
            event.preventDefault();
            onClick(event);
        }
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (NavItem);


/***/ }),

/***/ 77966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Robots = function(robots) {
    // Set meta tag if this build is used for production traffic
    var isLive = "true" === "true";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
        name: "robots",
        content: isLive ? robots || "index, follow" : "noindex, nofollow",
        "data-test": "robots-meta"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Robots);


/***/ }),

/***/ 68923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ products_grid; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/button-new/index.tsx
var button_new = __webpack_require__(76712);
// EXTERNAL MODULE: ./src/components/impression-tracker/new-impression-tracker.tsx
var new_impression_tracker = __webpack_require__(20286);
// EXTERNAL MODULE: ./src/components/product-card/skeleton/index..tsx
var index_ = __webpack_require__(49997);
// EXTERNAL MODULE: ./src/components/product-impressions-tracker/index.tsx
var product_impressions_tracker = __webpack_require__(40321);
// EXTERNAL MODULE: ./src/constants/feature-flag.ts
var feature_flag = __webpack_require__(93841);
// EXTERNAL MODULE: ./src/contexts/segmentation.tsx + 3 modules
var segmentation = __webpack_require__(42067);
// EXTERNAL MODULE: ./src/hooks/common/use-mobile.tsx
var use_mobile = __webpack_require__(44621);
// EXTERNAL MODULE: ./src/hooks/product/use-bestseller-style-properties.ts
var use_bestseller_style_properties = __webpack_require__(24981);
// EXTERNAL MODULE: ./src/modules/collection/state/index.tsx + 4 modules
var state = __webpack_require__(95961);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/tracking/index.ts
var tracking = __webpack_require__(1975);
// EXTERNAL MODULE: ./src/utils/contentful.ts
var contentful = __webpack_require__(74803);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./src/components/experience-wrapper/index.tsx
var experience_wrapper = __webpack_require__(31556);
// EXTERNAL MODULE: ./src/assets/icons/chevron-right-stroke.svg
var chevron_right_stroke = __webpack_require__(30372);
;// CONCATENATED MODULE: ./src/assets/icons/main-icon.svg
var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgMainIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 46"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 21.5,
    stroke: "currentcolor",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 18
  })), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#main-icon_svg__clip0)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "currentcolor",
    d: "M33.676 17.28c.724-1.74.144-3.612-.855-4.003-.999-.39-2.751.55-3.473 2.288-.722 1.739-.632 3.418.855 4.002 1.486.585 2.75-.549 3.473-2.287zm-2.412 6.452c-.559-2.402-2.586-3.982-4.924-3.459-1.602.357-1.812 1.92-2.976 2.18-1.164.262-2.276-1.006-3.866-.65-2.347.524-3.467 2.814-2.907 5.207.15.629.399 1.23.739 1.784.158.262.333.513.525.752 2.661 3.348 6.965 4.401 6.965 4.401.367.067.744.06 1.108-.024a2.734 2.734 0 001.006-.456s3.41-2.771 4.318-6.923c.062-.297.109-.598.14-.9a6.331 6.331 0 00-.128-1.922v.01zm-3.906-10.107c-.11-2.07-1.584-3.683-2.774-3.625-1.19.058-2.49 1.807-2.384 3.878.106 2.07.999 3.709 2.77 3.622 1.772-.086 2.491-1.805 2.388-3.875zm-7.135.427c-.874-2.03-2.947-3.114-4.112-2.632-1.164.482-1.816 2.687-.94 4.717.877 2.03 2.377 3.349 4.112 2.631 1.736-.717 1.816-2.684.94-4.716zm-5.802 4.942c-1.392-1.231-3.345-1.337-4.053-.571-.707.765-.404 2.654.983 3.885 1.387 1.231 3.006 1.71 4.053.573 1.046-1.136.404-2.656-.983-3.887z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "main-icon_svg__clip0"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h24v24H0z",
    transform: "translate(10 10)"
  })))));
}
/* harmony default export */ var main_icon = (SvgMainIcon);
// EXTERNAL MODULE: ./src/assets/icons/rating.svg
var rating = __webpack_require__(60988);
// EXTERNAL MODULE: ./src/hooks/gtm/use-impression-tracking.tsx + 1 modules
var use_impression_tracking = __webpack_require__(93579);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/tracking/gtm/index.ts + 1 modules
var gtm = __webpack_require__(71295);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/components/image/index.tsx
var components_image = __webpack_require__(10472);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/ads-tile/index.tsx












var AdsTile = function(param) {
    var adText = param.adText, adTitle = param.adTitle, backgroundColor = param.backgroundColor, collectionTitle = param.collectionTitle, desktopImage = param.desktopImage, link = param.link, mobileImage = param.mobileImage, position = param.position, quoteTile = param.quoteTile, urlParam = param.urlParam;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, query = ref.query;
    var getBackgroundColor = function() {
        switch(backgroundColor){
            case "Brand-Blue":
                return "#1A335B";
            case "Red-Sale":
                return "#FF5768";
            case "None":
                return "transparent";
            default:
                return "#1A335B";
        }
    };
    var $adsTileEl = react.useRef(null);
    (0,use_impression_tracking/* default */.Z)({
        ref: $adsTileEl,
        impressionStoreKey: "".concat(collectionTitle, "-adtile"),
        impressionId: "".concat(collectionTitle, "-").concat(position),
        trackingFn: function(isIn) {
            if (isIn) {
                (0,gtm/* gtm */.w)({
                    group: gtm/* Gtm.GroupName.AdTile */.P.Df.AdTile,
                    name: gtm/* Gtm.CommonEventName.Impression */.P.IE.Impression,
                    data: {
                        impression: {
                            list: collectionTitle,
                            position: position + 1
                        },
                        nonInteractive: true
                    }
                });
            }
        }
    });
    var trackClick = react.useCallback(function() {
        (0,gtm/* gtm */.w)({
            group: gtm/* Gtm.GroupName.AdTile */.P.Df.AdTile,
            name: gtm/* Gtm.CommonEventName.Click */.P.IE.Click,
            data: {
                click: {
                    list: collectionTitle,
                    position: position + 1
                }
            }
        });
    }, [
        collectionTitle,
        position
    ]);
    var scrollToElement = react.useCallback(function() {
        trackClick();
        if (window) {
            var headerEl = document.querySelector("#header");
            var headerHeight = headerEl ? headerEl.offsetHeight : 0;
            var scrollEl = document.querySelector(link || "body");
            var scrollElPos = scrollEl ? scrollEl.offsetTop : 0;
            window.scrollTo({
                behavior: "smooth",
                left: 0,
                top: scrollElPos - headerHeight
            });
        }
    }, [
        trackClick,
        link
    ]);
    var adsTileChildren = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: $adsTileEl,
        "data-test": "ads-tile",
        className: "relative h-full w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundColor: getBackgroundColor()
                },
                className: classnames_default()("absolute z-10 h-full w-full rounded-lg opacity-90", quoteTile && "opacity-100")
            }),
            desktopImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden w-full md:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                    sizes: "(min-width: 1024px) 310px, (min-width: 769px) 248px",
                    className: "rounded-lg",
                    layout: "fill",
                    objectFit: "cover",
                    loading: "lazy"
                }, desktopImage))
            }),
            mobileImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({
                    sizes: "100vw",
                    className: "rounded-lg",
                    layout: adTitle || adText ? "fill" : "responsive",
                    objectFit: "cover",
                    loading: "lazy"
                }, mobileImage))
            }),
            (adText || adTitle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    overflowWrap: "anywhere"
                },
                className: "relative z-30 flex h-full w-full rounded-lg p-4 lg:py-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col ",
                        children: [
                            quoteTile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rating/* default */.Z, {
                                    className: "mb-2 h-3 w-auto text-brand-star-yellow lg:-mt-2"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-1 flex-col justify-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: classnames_default()("text-2xl font-black text-other-white lg:pb-4 lg:text-3xl", quoteTile ? "italic" : " xl:text-4xl"),
                                    children: adTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-text-dark-bg-contrast-white",
                                        children: adText
                                    }),
                                    quoteTile && /*#__PURE__*/ (0,jsx_runtime.jsx)(main_icon, {
                                        className: "w-6 text-transparent "
                                    })
                                ]
                            })
                        ]
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-mr-2 flex md:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right_stroke/* default */.Z, {
                            className: "h-auto w-5 text-text-dark-bg-contrast-white"
                        })
                    })
                ]
            })
        ]
    });
    if (link) {
        if (link.charAt(0) === "#") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "block w-full rounded-lg md:hover:shadow-xl",
                onClick: scrollToElement,
                children: adsTileChildren
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: trackClick,
                className: "block w-full rounded-lg md:hover:shadow-xl",
                children: adsTileChildren
            })
        });
    } else if (urlParam) {
        var _params = {};
        try {
            var searchParams = new URLSearchParams(urlParam);
            searchParams.forEach(function(value, key) {
                _params[key] = value;
            });
        } catch (error) {
            console.log("urlParam is not valid url query", urlParam);
            _params = {};
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: {
                pathname: pathname,
                query: (0,_object_spread/* default */.Z)({}, query, _params)
            },
            passHref: true,
            replace: true,
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: trackClick,
                className: "block w-full md:hover:shadow-xl",
                children: adsTileChildren
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: adsTileChildren
    });
};
/* harmony default export */ var ads_tile = (AdsTile);

;// CONCATENATED MODULE: ./src/modules/collection/components/ad-tile-wrapper.tsx






/**
 * Fix for the bug where nt_experience is not captured.
 * Wrapping with memo fix the problem.
 * this problem should be fixed more properly.
 * @see : https://petsdeli.atlassian.net/browse/PT-5616
 */ var AdTileWrapper = function(param) {
    var title = param.title, entry = param.entry;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(experience_wrapper/* default */.Z, {
        entry: entry,
        component: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ads_tile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                collectionTitle: title
            }));
        }
    });
};
/* harmony default export */ var ad_tile_wrapper = (/*#__PURE__*/(0,react.memo)(AdTileWrapper));

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./src/components/nav-item/index.tsx
var nav_item = __webpack_require__(71707);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(92918);
;// CONCATENATED MODULE: ./src/modules/collection/components/allergies-filter/index.tsx












/**
 * Filter component for filtering products by allergen.
 * It is only shown on the collection page 'fur-hunde-unvertraeglichkeiten-allergien'
 */ var AllergiesFilter = function(_param) {
    var activeAllergyFilter = _param.activeAllergyFilter, className = _param.className, collectionProducts = _param.collectionProducts, setTemporarySelectedAllergies = _param.setTemporarySelectedAllergies, toggleActiveAllergyFilter = _param.toggleActiveAllergyFilter, toggleAllergyFilter = _param.toggleAllergyFilter, toggleFilter = _param.toggleFilter, divProps = (0,_object_without_properties/* default */.Z)(_param, [
        "activeAllergyFilter",
        "className",
        "collectionProducts",
        "setTemporarySelectedAllergies",
        "toggleActiveAllergyFilter",
        "toggleAllergyFilter",
        "toggleFilter"
    ]);
    var allergyTags = [
        "getreidefrei",
        "rind",
        "huhn",
        "pute",
        "ente",
        "fisch",
        "kartoffel",
        "lamm",
        "pferd",
        "ziege",
        "suskartoffel", 
    ];
    var availableTagsSet = (0,react.useMemo)(function() {
        return new Set(collectionProducts.flatMap(function(product) {
            return product.tags.map(function(tag) {
                return (0,strings/* slugify */.lV)(tag);
            });
        }));
    }, [
        collectionProducts
    ]);
    var filteredAllergyTags = allergyTags.filter(function(tag) {
        return availableTagsSet.has(tag);
    });
    var handleToggleAllergyFilter = (0,react.useCallback)(function(tag) {
        // Since the tag 'getreidefrei' is already present and used in products to identify them as wheat-free,
        // it was decided to use the current tag to display products without this allergen,
        // instead of excluding them as is the case with other allergens.
        // This allows us to avoid having to create and add a new tag such as 'getreide' to identify all products containing this allergen.
        if (tag === "getreidefrei") {
            toggleFilter(tag);
            toggleActiveAllergyFilter(tag);
        } else {
            toggleAllergyFilter(tag);
            toggleActiveAllergyFilter(tag);
        }
        setTemporarySelectedAllergies === null || setTemporarySelectedAllergies === void 0 ? void 0 : setTemporarySelectedAllergies(function(prev) {
            if (prev === null || prev === void 0 ? void 0 : prev.includes(tag)) {
                return prev.filter(function(item) {
                    return item !== tag;
                });
            }
            return (0,_to_consumable_array/* default */.Z)(prev !== null && prev !== void 0 ? prev : []).concat([
                tag
            ]);
        });
    }, [
        setTemporarySelectedAllergies,
        toggleActiveAllergyFilter,
        toggleAllergyFilter,
        toggleFilter, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(new_impression_tracker/* default */.Z, {
        element: "Allergy Filter",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: classnames_default()("mt-1.5 items-center lg:mb-0 lg:flex lg:px-0", className)
        }, divProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mb-1.5 mr-3 inline-block text-sm lg:mb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "cdp:allergy-filter:header"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap gap-2",
                    children: filteredAllergyTags.filter(function(tag) {
                        return availableTagsSet.has(tag);
                    }).map(function(tag) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_item/* default */.Z, {
                            className: "h-7 capitalize lg:h-10",
                            selected: activeAllergyFilter.includes(tag),
                            onClick: function() {
                                handleToggleAllergyFilter(tag);
                                activeAllergyFilter.includes(tag) ? (0,tracking/* gtm */.wT)((0,tracking/* unselectElement */.ey)({
                                    element: [
                                        "Allergy Filter",
                                        tag
                                    ]
                                })) : (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
                                    element: [
                                        "Allergy Filter",
                                        tag
                                    ]
                                }));
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "cdp:allergy-filter:".concat(tag)
                            })
                        }, tag);
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ var allergies_filter = (AllergiesFilter);

// EXTERNAL MODULE: ./src/modules/collection/components/collection-filter/laptop/index.tsx + 1 modules
var laptop = __webpack_require__(79137);
// EXTERNAL MODULE: ./src/modules/collection/components/collection-filter/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(25827);
// EXTERNAL MODULE: ./src/modules/collection/state/available-choices.ts
var available_choices = __webpack_require__(52419);
// EXTERNAL MODULE: ./src/components/hero-filter-button/index.tsx
var hero_filter_button = __webpack_require__(19287);
;// CONCATENATED MODULE: ./src/modules/collection/components/hero-filter/filter-button.tsx





/**
 * Button for the hero filter component.
 * With memo, only the affected filter button will be re-rendered, if a button is updated,
 * reducing the overall rendering time.
 */ var HeroFilterButton = /*#__PURE__*/ (0,react.memo)(function(param) {
    var filterName = param.filterName;
    var ref = (0,state/* useCollectionState */.IO)(), appliedFilter = ref.appliedFilter, toggleFilter = ref.toggleFilter;
    var handleToggleFilter = (0,react.useCallback)(function() {
        toggleFilter(filterName);
        (0,tracking/* gtm */.wT)((appliedFilter.includes(filterName) ? tracking/* unselectElement */.ey : tracking/* selectElement */.G7)({
            element: [
                "Hero Filter",
                filterName
            ]
        }));
    }, [
        appliedFilter,
        toggleFilter,
        filterName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_filter_button/* default */.Z, {
        filterName: filterName,
        handleToggleFilter: handleToggleFilter,
        isSelected: appliedFilter.includes(filterName)
    });
});
HeroFilterButton.displayName = "HeroFilterButton";
/* harmony default export */ var filter_button = (HeroFilterButton);

;// CONCATENATED MODULE: ./src/modules/collection/components/hero-filter/index.tsx.tsx






/**
 * A component that renders the main filter options with images for a collection
 */ var HeroFilterContainer = function(param) {
    var className = param.className, collectionProducts = param.collectionProducts, filterConfig = param.filterConfig;
    var ref;
    var availableFilterMap = (0,available_choices/* useAvailableFilterMap */.o)(collectionProducts, filterConfig);
    if (!("hero-filter" in availableFilterMap)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(new_impression_tracker/* default */.Z, {
        element: "Hero Filter",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-test": "hero-filter",
            className: classnames_default()("flex items-center gap-5", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "hidden text-sm lg:block",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "landingpage:category-slider:title-EC"
                        }),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("grid grid-cols-12 gap-2 lg:flex"),
                    children: (ref = availableFilterMap["hero-filter"]) === null || ref === void 0 ? void 0 : ref.tags.map(function(filterName) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_button, {
                            filterName: filterName
                        }, filterName);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var index_tsx = (HeroFilterContainer);

// EXTERNAL MODULE: ./src/modules/collection/components/products-grid/best-seller-wrapper/index.tsx
var best_seller_wrapper = __webpack_require__(19875);
;// CONCATENATED MODULE: ./src/modules/collection/components/products-grid/index.tsx























var featureFlg = (0,feature_flag/* getFeatureFlag */.O)(feature_flag/* FeatureFlag.dynamicUxTest */.T.dynamicUxTest);
var ProductCard = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48457));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48457)
            ];
        }
    }
});
var TRACKING_NAME = "Button Load More Products";
/**
 * This component is responsible for rendering the products grid of a collection.
 * It also renders the filter and the allergy filter.
 */ var ProductsGrid = function(param) {
    var bestsellerSectionClassName = param.bestsellerSectionClassName, containerRef = param.containerRef, contentfulData = param.contentfulData, customButton = param.customButton, _omitBestSeller = param.omitBestSeller, omitBestSeller = _omitBestSeller === void 0 ? false : _omitBestSeller, productsLimit = param.productsLimit, shouldShowAllergyFilter = param.shouldShowAllergyFilter, shouldShowBlackRibbon = param.shouldShowBlackRibbon, showFilter = param.showFilter, showMoreButton = param.showMoreButton, trackingElementName = param.trackingElementName, setTemporarySelectedAllergies = param.setTemporarySelectedAllergies, additionalQuery = param.additionalQuery;
    var ref = (0,segmentation/* useSegmentationContext */.M)(), multipleSegmentation = ref.multipleSegmentation, shouldOmitPersonalization = ref.shouldOmitPersonalization;
    var isMobile = (0,use_mobile/* default */.Z)();
    var ref1 = (0,state/* useCollectionState */.IO)(), isValidating = ref1.isValidating, collection = ref1.collection, limitOfProductsToShow = ref1.limitOfProductsToShow, visibleProducts = ref1.visibleProducts, setLimitOfProductsToShow = ref1.setLimitOfProductsToShow, appliedFilter = ref1.appliedFilter, filterConfig = ref1.filterConfig, activeAllergyFilter = ref1.activeAllergyFilter, resetFilter = ref1.resetFilter, toggleFilter = ref1.toggleFilter, toggleActiveAllergyFilter = ref1.toggleActiveAllergyFilter, toggleAllergyFilter = ref1.toggleAllergyFilter, trackingListName = ref1.trackingListName;
    (0,react.useEffect)(function() {
        if (productsLimit) {
            setLimitOfProductsToShow(productsLimit);
        } else {
            setLimitOfProductsToShow(undefined);
        }
    }, [
        productsLimit,
        setLimitOfProductsToShow
    ]);
    var ref2 = containerRef !== null && containerRef !== void 0 ? containerRef : /*#__PURE__*/ (0,react.createRef)();
    var adsTiles = (0,react.useMemo)(function() {
        var adtiles = [];
        if (contentfulData && (0,contentful/* isLegacyProductPageModel */.BV)(contentfulData)) {
            var ref;
            (ref = contentfulData.fields.collectionsAdsTiles) === null || ref === void 0 ? void 0 : ref.map(function(tile) {
                adtiles.push({
                    // subtract as position begins with 1
                    index: tile.fields.position - 1,
                    value: tile
                });
            });
        }
        return adtiles;
    }, [
        contentfulData
    ]);
    var visibleElements = (0,react.useMemo)(function() {
        var sortedAdtiles = (0,_to_consumable_array/* default */.Z)(adsTiles).sort(function(a, b) {
            return a.index - b.index;
        });
        var filteredBestsellers = visibleProducts.filter(function(product) {
            return omitBestSeller || shouldOmitPersonalization ? product : !product.getIsBestSeller({
                segment: multipleSegmentation === null || multipleSegmentation === void 0 ? void 0 : multipleSegmentation.lastSegmentation
            });
        });
        // Only when dynamic-ux is not available, we re-sort by availability
        if (!featureFlg) {
            filteredBestsellers.sort(function(a, b) {
                if (a.availableForSale === b.availableForSale) return 0;
                return a.availableForSale ? -1 : 1; //
            });
        }
        var _visibleProducts = (0,_to_consumable_array/* default */.Z)(filteredBestsellers).slice(0, limitOfProductsToShow);
        for(var i = adsTiles.length - 1; i >= 0; i--){
            var _i = sortedAdtiles[i], index = _i.index, value = _i.value;
            if (index < _visibleProducts.length) {
                _visibleProducts.splice(index, 0, value);
            }
        }
        return _visibleProducts;
    }, [
        adsTiles,
        limitOfProductsToShow,
        multipleSegmentation === null || multipleSegmentation === void 0 ? void 0 : multipleSegmentation.lastSegmentation,
        omitBestSeller,
        shouldOmitPersonalization,
        visibleProducts, 
    ]);
    var bestsellerProducts = (0,react.useMemo)(function() {
        if (omitBestSeller) return [];
        return visibleProducts.filter(function(product) {
            return product.availableForSale && product.getIsBestSeller({
                segment: multipleSegmentation === null || multipleSegmentation === void 0 ? void 0 : multipleSegmentation.lastSegmentation
            });
        });
    }, [
        multipleSegmentation === null || multipleSegmentation === void 0 ? void 0 : multipleSegmentation.lastSegmentation,
        omitBestSeller,
        visibleProducts
    ]);
    var ref3 = (0,use_bestseller_style_properties/* default */.Z)({
        bestsellerProductsLength: bestsellerProducts.length
    }), paddingValue = ref3.paddingValue, shouldApplyPadding = ref3.shouldApplyPadding;
    var moreProductsWithoutVisibleProducts = (0,react.useMemo)(function() {
        return collection.products.filter(function(product) {
            return !visibleProducts.find(function(visibleProduct) {
                return visibleProduct.id === product.id;
            });
        }).slice(0, 9);
    }, [
        collection,
        visibleProducts
    ]);
    /**
   * Fake loading for test
   * @see https://petsdeli.atlassian.net/browse/PT-6960
   */ var ref4 = (0,react.useState)(false), fakeLoading = ref4[0], setFakeLoading = ref4[1];
    var triggerFakeLoading = (0,react.useCallback)(function() {
        setFakeLoading(true);
        var id = setTimeout(function() {
            setFakeLoading(false);
        }, 1000);
        return function() {
            return clearTimeout(id);
        };
    }, []);
    var isLoading = fakeLoading || isValidating;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-1 gap-4 lg:grid-cols-4 lg:gap-5",
            ref: ref2,
            children: [
                collection.products.length > 0 && showFilter ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-1 hidden lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sticky top-0 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(laptop/* default */.Z, {
                                    appliedFilter: appliedFilter,
                                    filterConfig: filterConfig,
                                    activeAllergyFilter: activeAllergyFilter,
                                    resetFilter: resetFilter,
                                    toggleFilter: toggleFilter,
                                    collectionProducts: collection.products,
                                    visibleProducts: visibleProducts
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {
                                    appliedFilter: appliedFilter,
                                    filterConfig: filterConfig,
                                    activeAllergyFilter: activeAllergyFilter,
                                    resetFilter: resetFilter,
                                    toggleFilter: toggleFilter,
                                    collectionProducts: collection.products,
                                    visibleProducts: visibleProducts,
                                    sortCallback: triggerFakeLoading
                                }),
                                shouldShowAllergyFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(allergies_filter, {
                                    activeAllergyFilter: activeAllergyFilter,
                                    collectionProducts: collection.products,
                                    setTemporarySelectedAllergies: setTemporarySelectedAllergies,
                                    toggleActiveAllergyFilter: toggleActiveAllergyFilter,
                                    toggleAllergyFilter: toggleAllergyFilter,
                                    toggleFilter: toggleFilter
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_tsx, {
                                    className: "mt-2",
                                    collectionProducts: collection.products,
                                    filterConfig: filterConfig
                                })
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-1 lg:col-span-3",
                    "data-test": "cdp-collection-tile-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_tsx, {
                            className: "mb-3 hidden lg:flex",
                            collectionProducts: collection.products,
                            filterConfig: filterConfig
                        }),
                        shouldShowAllergyFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-[30px] hidden lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(allergies_filter, {
                                activeAllergyFilter: activeAllergyFilter,
                                collectionProducts: collection.products,
                                setTemporarySelectedAllergies: setTemporarySelectedAllergies,
                                toggleActiveAllergyFilter: toggleActiveAllergyFilter,
                                toggleAllergyFilter: toggleAllergyFilter,
                                toggleFilter: toggleFilter
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-1 gap-3 lg:grid-cols-3 lg:gap-5",
                            "data-test": "cdp-collection-tile-wrapper",
                            children: [
                                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: new Array(9).fill(null).map(function(_, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_/* default */.Z, {}, index);
                                    })
                                }),
                                !isLoading && !shouldOmitPersonalization && bestsellerProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(best_seller_wrapper/* default */.Z, {
                                    bestSellerLength: bestsellerProducts.length,
                                    message: collection.getBestSellerTitle({
                                        segmentation: multipleSegmentation === null || multipleSegmentation === void 0 ? void 0 : multipleSegmentation.lastSegmentation
                                    }),
                                    className: classnames_default()(bestsellerSectionClassName, "lg:ml-0"),
                                    isMobile: isMobile,
                                    children: bestsellerProducts.map(function(product, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_impressions_tracker/* default */.Z, {
                                            element: "Product List",
                                            list: collection.title,
                                            position: index,
                                            product: product,
                                            trackingGroupName: trackingListName || "",
                                            collectionHandle: trackingListName,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-test": "product-tile-container",
                                                className: "flex rounded-lg bg-other-white",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard, {
                                                    collectionTitle: collection.title,
                                                    isBestSeller: true,
                                                    position: index,
                                                    product: product,
                                                    starSize: isMobile ? "small" : "medium",
                                                    trackingElementName: trackingElementName,
                                                    additionalQuery: additionalQuery,
                                                    shouldShowBlackRibbon: shouldShowBlackRibbon
                                                })
                                            })
                                        }, "".concat(product.id, "-").concat(product.promoteVariantId));
                                    })
                                }),
                                !isLoading && visibleElements.map(function(element, index) {
                                    if (element["handle"]) {
                                        var product = element;
                                        var _shouldApplyPadding = shouldApplyPadding(index);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_impressions_tracker/* default */.Z, {
                                            element: trackingElementName !== null && trackingElementName !== void 0 ? trackingElementName : "Product List",
                                            list: collection.title,
                                            position: index,
                                            product: product,
                                            trackingGroupName: trackingListName || "",
                                            collectionHandle: trackingListName,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-test": "product-tile-container",
                                                className: "flex",
                                                style: {
                                                    paddingTop: _shouldApplyPadding ? "".concat(paddingValue, "px") : "",
                                                    paddingBottom: _shouldApplyPadding ? "8px" : ""
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard, {
                                                    collectionTitle: collection.title,
                                                    isBestSeller: shouldOmitPersonalization ? false : !omitBestSeller && product.getIsBestSeller({
                                                        segment: multipleSegmentation === null || multipleSegmentation === void 0 ? void 0 : multipleSegmentation.lastSegmentation
                                                    }),
                                                    position: index,
                                                    product: product,
                                                    starSize: isMobile ? "small" : "medium",
                                                    trackingElementName: trackingElementName,
                                                    additionalQuery: additionalQuery,
                                                    shouldShowBlackRibbon: shouldShowBlackRibbon
                                                })
                                            })
                                        }, "".concat(product.id, "-").concat(product.promoteVariantId));
                                    } else if (element["sys"]) {
                                        var adtile = element;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ad_tile_wrapper, {
                                            entry: adtile,
                                            title: collection.title
                                        }, adtile.sys.id);
                                    }
                                })
                            ]
                        }),
                        !limitOfProductsToShow && visibleProducts.length < 9 && !!moreProductsWithoutVisibleProducts.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "m-2 mt-4 border-t border-grey-200 pt-6 text-center text-xl font-black lg:mt-10 lg:pt-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "cdp:similarproducts"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 gap-3 lg:grid-cols-3 lg:gap-5 ",
                                    "data-test": "collection-list",
                                    children: moreProductsWithoutVisibleProducts.map(function(product, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_impressions_tracker/* default */.Z, {
                                            element: "Product List",
                                            list: collection.title,
                                            position: index,
                                            product: product,
                                            trackingGroupName: trackingListName || "",
                                            collectionHandle: trackingListName,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-test": "sometext3",
                                                className: "flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard, {
                                                    product: product,
                                                    collectionTitle: collection.title,
                                                    position: index,
                                                    additionalQuery: additionalQuery
                                                })
                                            })
                                        }, "more-".concat(product.id, "-").concat(product.promoteVariantId));
                                    })
                                })
                            ]
                        }),
                        showMoreButton && limitOfProductsToShow && !customButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(new_impression_tracker/* default */.Z, {
                            element: TRACKING_NAME,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("my-4 flex justify-center", isMobile && "container"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_new/* default */.Z, {
                                    size: "base",
                                    className: "w-1/2 lg:w-1/3",
                                    layout: "outline",
                                    onClick: function() {
                                        setLimitOfProductsToShow(undefined);
                                        (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
                                            element: TRACKING_NAME
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "cdp:standalone-cdp:load-more"
                                    })
                                })
                            })
                        }),
                        customButton
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var products_grid = (ProductsGrid);


/***/ }),

/***/ 10472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_image_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6213);







var Image = function(_param) {
    var className = _param.className, fields = _param.fields, _style = _param.style, style = _style === void 0 ? {} : _style, layout = _param.layout, objectFit = _param.objectFit, sizes = _param.sizes, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "fields",
        "style",
        "layout",
        "objectFit",
        "sizes"
    ]);
    if (!fields) return null;
    if (fields.file.url.indexOf(".svg") > -1) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: fields.file.url,
            style: style,
            className: className,
            alt: fields.title || fields.description || ""
        });
    }
    var props = {};
    if (layout !== "fill") {
        var ref, ref1;
        props.width = (ref = fields.file.details.image) === null || ref === void 0 ? void 0 : ref.width;
        props.height = (ref1 = fields.file.details.image) === null || ref1 === void 0 ? void 0 : ref1.height;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        loader: utils_image_loader__WEBPACK_IMPORTED_MODULE_6__/* .contentful */ .d,
        alt: fields.title || fields.description || "",
        title: fields.title || fields.description || "",
        className: className,
        src: fields.file.url
    }, props), {
        layout: layout,
        objectFit: objectFit,
        sizes: sizes
    }), others));
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 6213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ contentful; },
/* harmony export */   "x": function() { return /* binding */ generalImageLoader; }
/* harmony export */ });
var normalizeSrc = function(src) {
    return src[0] === "/" ? src.slice(1) : src;
};
/**
 * Image loader implementation for Shopify and PDEX images used with `Image` component from Next.js.
 * @see https://nextjs.org/docs/api-reference/next/image#loader
 */ var generalImageLoader = function(param) {
    var src = param.src, width = param.width;
    try {
        var url = new URL(src);
        if (url.hostname.indexOf("petsdeli") > -1) {
            // Add a new query parameter
            url.searchParams.append("w", String(width));
            url.searchParams.append("f", "jpg");
            return url.href;
        } else {
            var newSrc = normalizeSrc(src).split(".jpg").join("_".concat(width, "x.jpg"));
            newSrc = newSrc.split(".png").join("_".concat(width, "x.png"));
            return newSrc;
        }
    } catch (error) {
        console.log(error, {
            src: src,
            width: width
        });
        return "";
    }
};
/**
 * Image loader implementation for Contentful images used with `Image` component from Next.js.
 * @see https://nextjs.org/docs/api-reference/next/image#loader
 */ var contentful = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    var params = [
        "w=" + width
    ];
    if (quality) {
        params.push("q=" + quality);
    }
    return "https:/".concat(normalizeSrc(src), "?").concat(params.join("&"));
};



/***/ })

}]);